import React from "react";

interface FooterProps {
  privacyPolicyUrl?: string;
  termsUrl?: string;
}

export function Footer({ privacyPolicyUrl, termsUrl }: FooterProps) {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gray-900 text-white py-8" style={{ paddingBottom: "calc(2rem + 5px)" }}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-sm text-gray-400">
            &copy; {currentYear} Way Up Creative. All rights reserved.
          </p>

          {(privacyPolicyUrl || termsUrl) && (
            <div className="flex gap-6">
              {privacyPolicyUrl && (
                <a
                  href={privacyPolicyUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Privacy Policy
                </a>
              )}
              {termsUrl && (
                <a
                  href={termsUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-400 hover:text-white transition-colors"
                >
                  Terms & Conditions
                </a>
              )}
            </div>
          )}
        </div>
      </div>
    </footer>
  );
}
